var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSahrawiArabDemocraticRepublic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58763 9.04344C0.5705 11.1469 0 13.5068 0 15.9999C0 18.4931 0.5705 20.8529 1.58763 22.9564L16 24.3478L30.4124 22.9564C31.4295 20.8529 32 18.4931 32 15.9999C32 13.5068 31.4295 11.1469 30.4124 9.04344L16 7.65213L1.58763 9.04344Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58887 22.9563C4.17674 28.3082 9.65737 31.9998 16.0007 31.9998C22.344 31.9998 27.8246 28.3082 30.4125 22.9563H1.58887Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58887 9.0435H30.4125C27.8246 3.69156 22.3441 0 16.0007 0C9.6573 0 4.17674 3.69156 1.58887 9.0435Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68579 4.68628C-1.56258 10.9347 -1.56258 21.0653 4.68579 27.3138C7.26786 24.7317 9.75117 22.2484 15.9995 16L4.68579 4.68628Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1744 16.0001C20.1744 13.669 21.8127 11.7215 24.0005 11.2438C23.6642 11.1703 23.3153 11.1305 22.957 11.1305C20.2675 11.1305 18.0874 13.3106 18.0874 16.0001C18.0874 18.6895 20.2675 20.8696 22.957 20.8696C23.3153 20.8696 23.6642 20.8298 24.0005 20.7564C21.8127 20.2786 20.1744 18.3312 20.1744 16.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2046 12.8695L24.8954 14.9954H27.1304L25.3222 16.309L26.0129 18.4347L24.2046 17.121L22.3964 18.4347L23.0872 16.309L21.2788 14.9954H23.5139L24.2046 12.8695Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSahrawiArabDemocraticRepublic);
export default __webpack_public_path__ + "static/media/sahrawi-arab-democratic-republic.acb7044d.svg";
export { ForwardRef as ReactComponent };